// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { tgfHooks } from "../framework/hooks/hooks";
import { PlayerData } from "./PlayerData";
import { YoutubeStorageManager } from "./storage/YoutubeStorageManager";
export var FriendManager = {
    isInitialized: false,
    unsuggestablePlayers: [],
    opponentHistory: {},
    initialize: function () {
        var self = this;
        this.unsuggestablePlayers = [tgfHooks.getPlayerID()];
        return new Promise(function (resolve, reject) {
            tgfHooks.getConnectedPlayersID(function (response) {
                self.friendIds = [];
                self.playerEntry = [];
                response.forEach(function (connectedPlayer) {
                    var entry = new PlayerData();
                    var pID = connectedPlayer["getID"]();
                    entry.setInfo(connectedPlayer);
                    self.playerEntry.push(entry);
                    self.friendIds.push(pID);
                }, self);
                YoutubeStorageManager.getPlayerData(["opponentHistory"], function (data) {
                    if (data["opponentHistory"]) {
                        self.opponentHistory = data["opponentHistory"];
                    }
                    self.isInitialized = true;
                    resolve();
                });
            });
        });
    },
    getSuggestedFriends: function (amount) {
        if (!this.isInitialized) {
            throw new Error("FriendManager is not initialized");
        }
        if (!amount) {
            throw new Error("Please specify how many friends to suggest");
        }
        var suggestedFriends = [];
        var prevIndices = [];
        var suggestableFriends = [];
        var suggestableIds = [];
        for (var i = 0; i < this.playerEntry.length; i++) {
            if (this.unsuggestablePlayers.indexOf(this.playerEntry[i].id) === -1) {
                suggestableFriends.push(this.playerEntry[i]);
                suggestableIds.push(this.playerEntry[i]["id"]);
            }
        }
        for (var id in this.opponentHistory) {
            if (suggestableIds.indexOf(id) === -1) {
                continue;
            }
            var spliced = false;
            for (var i = 0; i < suggestedFriends.length; i++) {
                if (this.opponentHistory[id] > this.opponentHistory[suggestedFriends[i]]) {
                    var index = this._getIndexByIdFromArray(id, suggestableFriends);
                    prevIndices.push(index);
                    var entry = suggestableFriends[index].clone();
                    entry.isSuggested = true;
                    suggestedFriends.splice(i, 0, entry);
                    spliced = true;
                    if (suggestedFriends.length > amount) {
                        suggestedFriends.splice(amount, 1);
                    }
                    break;
                }
            }
            if (!spliced && suggestedFriends.length < amount) {
                var index = this._getIndexByIdFromArray(id, suggestableFriends);
                prevIndices.push(index);
                var entry = suggestableFriends[index].clone();
                entry.isSuggested = true;
                suggestedFriends.push(entry);
            }
        }
        var max = suggestableFriends.length;
        amount = Math.min(suggestableFriends.length, amount);
        for (var i = suggestedFriends.length; i < amount; i++) {
            var index = Math.floor(Math.random() * max);
            while (prevIndices.indexOf(index) != -1) {
                index = Math.floor(Math.random() * max);
            }
            prevIndices.push(index);
            var entry = suggestableFriends[index].clone();
            entry.isSuggested = true;
            suggestedFriends.push(entry);
        }
        return suggestedFriends;
    },
    _getIndexByIdFromArray: function (id, array) {
        for (var i = 0; i < array.length; i++) {
            if (array[i].id === id) {
                return i;
            }
        }
    },
    getFriendIds: function () {
        if (!this.isInitialized) {
            throw new Error("FriendManager is not initialized");
        }
        return this.friendIds;
    },
    getFriendData: function () {
        if (!this.isInitialized) {
            throw new Error("FriendManager is not initialized");
        }
        return this.playerEntry;
    },
    setUnsuggestablePlayersFromMatchList: function (data) {
        if (!this.isInitialized) {
            throw new Error("FriendManager is not initialized");
        }
        this.unsuggestablePlayers = [tgfHooks.getPlayerID()];
        for (var contextId in data) {
            var lobbyData = data[contextId]["lobby"];
            if (lobbyData["state"] != "GAMEOVER") {
                if (lobbyData["initiatingPlayerData"]["id"] === tgfHooks.getPlayerID()) {
                    this.unsuggestablePlayers.push(lobbyData["otherPlayerData"]["id"]);
                }
                else {
                    this.unsuggestablePlayers.push(lobbyData["initiatingPlayerData"]["id"]);
                }
            }
        }
    },
    addPlayerIdToHistory: function (playerId) {
        if (this.opponentHistory[playerId] === undefined) {
            this.opponentHistory[playerId] = 1;
        }
        else {
            this.opponentHistory[playerId]++;
        }
        YoutubeStorageManager.savePlayerData(["opponentHistory"], [this.opponentHistory], function () {
            console.log("saved opponent history");
        }, function (error) {
            console.log(error);
        });
    },
};
